export default __webpack_public_path__ + "static/media/home-startup-service-img-02.39b6965a.jpg";